import React, { useState, useEffect } from 'react';
import { fetchActiveEvents, normalizeUrl } from '../services/api';
import { useConfig } from '../ConfigContextCore';
import vsezLogo from '../assets/images/VSEZ_LOGO.png';

const EventDisplay = ({ type = 'banner' }) => {
    const { siteData } = useConfig();
    const activeEvents = siteData.activeEvents || [];
    const [showPopup, setShowPopup] = useState(true);
    const [dismissedBanners, setDismissedBanners] = useState([]);

    useEffect(() => {
        // Load previously dismissed banners from session
        const dismissed = JSON.parse(sessionStorage.getItem('vsez_dismissed_banners') || '[]');
        setDismissedBanners(dismissed);
    }, []);

    const [currentModalIndex, setCurrentModalIndex] = useState(0);
    const activeModals = activeEvents.filter(e => e.display_type === 'modal' && isEventActive(e));
    const currentModal = activeModals[currentModalIndex];

    const handleDismissBanner = (id) => {
        const newDismissed = [...dismissedBanners, id];
        setDismissedBanners(newDismissed);
        sessionStorage.setItem('vsez_dismissed_banners', JSON.stringify(newDismissed));
    };

    function isEventActive(ev) {
        if (!ev) return false;
        if (ev.is_active === false || ev.is_active === 0 || ev.is_active === '0') return false;
        const now = new Date();
        const start = new Date(ev.start_date);
        const end = new Date(ev.end_date);
        if (isNaN(start.getTime()) || isNaN(end.getTime())) return true;
        return now >= start && now <= end;
    }

    useEffect(() => {
        if (activeModals.length > 0) {
            const sessionKey = `vsez_modal_batch_seen_${activeModals.map(m => m.id).join('_')}`;
            if (!sessionStorage.getItem(sessionKey)) {
                // sessionStorage.setItem(sessionKey, 'true');
            }
        }
    }, [activeModals]);

    const banners = activeEvents.filter(e => e.id && e.display_type === 'banner' && !dismissedBanners.includes(e.id) && isEventActive(e));
    const popups = activeEvents.filter(e => e.id && e.display_type === 'popup' && isEventActive(e));

    if (type === 'banner' && banners.length > 0) {
        return (
            <div className="event-banners-container">
                {banners.map(banner => (
                    <div key={banner.id} className="event-banner-strip">
                        <div className="container event-banner-flex">
                            {banner.image_url && (
                                <img
                                    src={normalizeUrl(banner.image_url)}
                                    className="event-banner-img"
                                    alt="Event"
                                />
                            )}
                            <div className="event-banner-content" dangerouslySetInnerHTML={{ __html: (banner.content || '').replace(/&nbsp;/g, ' ') }} />
                            <button
                                className="banner-close-btn"
                                onClick={() => handleDismissBanner(banner.id)}
                                title="Dismiss Announcement"
                            >
                                &times;
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (type === 'overlay') {
        return (
            <>
                {/* Modal Overlay (Premium Vignette) */}
                {currentModal && (
                    <div className="event-vignette-overlay" onClick={() => setCurrentModalIndex(-1)}>
                        <div className="event-vignette-card animate-fade-in" onClick={(e) => e.stopPropagation()}>
                            {/* Close Button: External floating pill */}
                            <button className="vignette-close-btn" onClick={() => setCurrentModalIndex(-1)}>X</button>

                            {/* Left Pane: Content */}
                            {/* <div className="vignette-left">
                                <img src={vsezLogo} className="vignette-logo" alt="VSEZ Logo" />
                                <h1 className="vignette-title">{currentModal.event_name}</h1>
                                {currentModal.subtitle && <div className="vignette-subtitle">{currentModal.subtitle}</div>}
                                <div className="vignette-description" dangerouslySetInnerHTML={{ __html: (currentModal.content || '').replace(/&nbsp;/g, ' ') }} />

                                {activeModals.length > 1 && (
                                    <div className="vignette-carousel-nav">
                                        <button
                                            onClick={() => setCurrentModalIndex(prev => (prev - 1 + activeModals.length) % activeModals.length)}
                                            className="nav-dot-btn"
                                        >
                                            <i className="fa fa-chevron-left"></i>
                                        </button>
                                        <div className="nav-dots">
                                            {activeModals.map((_, idx) => (
                                                <span key={idx} className={`nav-dot ${idx === currentModalIndex ? 'active' : ''}`} />
                                            ))}
                                        </div>
                                        <button
                                            onClick={() => setCurrentModalIndex(prev => (prev + 1) % activeModals.length)}
                                            className="nav-dot-btn"
                                        >
                                            <i className="fa fa-chevron-right"></i>
                                        </button>
                                    </div>
                                )}
                            </div> */}

                            {/* Right Pane: Large Image + CTA bar */}
                            <div className="vignette-right">
                                <div className="vignette-img-container">
                                    {currentModal.image_url && (
                                        <img
                                            src={normalizeUrl(currentModal.image_url)}
                                            className="vignette-img"
                                            alt="Featured Event"
                                        />
                                    )}
                                </div>
                                {currentModal.link_url && (
                                    <a href={currentModal.link_url} className="vignette-cta-bar">
                                        <span>{currentModal.button_text || 'Learn More'}</span>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* Bottom Popup */}
                {showPopup && popups.map(popup => (
                    <div key={popup.id} className="event-popup-corner">
                        <button className="close-btn-mini" onClick={() => setShowPopup(false)}>&times;</button>
                        {popup.image_url && (
                            <img
                                src={normalizeUrl(popup.image_url)}
                                className="event-popup-img mb-3"
                                alt="Event"
                                style={{ width: '100%', borderRadius: '6px', maxHeight: '150px', objectFit: 'cover' }}
                            />
                        )}
                        {/* <div className="event-popup-content" dangerouslySetInnerHTML={{ __html: (popup.content || '').replace(/&nbsp;/g, ' ') }} /> */}
                    </div>
                ))}
            </>
        );
    }

    return null;
};

export default EventDisplay;
